<template>
    <div>
        <b-card id="driver_wrapper" bg-variant="white" title="Informações da rota" class="card-tracking">
            <b-card-body class="p-10">
                <b-row class="mb-0">
                    <b-col md="auto"><b-img :src="getDriverImageUrl()" id="driver_picture"></b-img></b-col>
                    <template v-if="distribution[0].progress == 0">
                        <b-col md="auto" class="d-flex align-self-center"><h4>{{distribution[0].full_name != null ? distribution[0].full_name.split(" ")[0] : "motorista"}} está iniciando a sua rota</h4></b-col>
                    </template>
                    <template v-else>
                        <template  v-if="distribution[0].status_stop_id == 1 || distribution[0].status_stop_id == 2">
                            <b-col md="auto" class="d-flex align-self-center"><h4>{{distribution[0].full_name != null ? distribution[0].full_name.split(" ")[0] : "motorista"}} está a caminho do seu endereço!</h4></b-col>
                        </template>
                        <template v-else>
                            <b-col md="auto" class="d-flex align-self-center"><h4>{{distribution[0].full_name != null ? distribution[0].full_name.split(" ")[0]: "motorista"}} está na entrega número {{ distribution[0].progress }}</h4></b-col>
                        </template>
                    </template>
                </b-row>
            </b-card-body>
        </b-card>
        <b-container id="route_tracking_wrapper" class="card card-tracking" v-if="this.data.distribution.length > 0
                                                                                    && this.data.documentInfo.status_stop_id != 3
                                                                                    && this.data.documentInfo.status_stop_id != 4
                                                                                    && this.data.documentInfo.status_stop_id != 8
                                                                                    && this.data.documentInfo.status_stop_id != 6
                                                                                    && this.data.documentInfo.status_stop_id != 9
                                                                                    && this.data.documentInfo.status_stop_id != 13
                                                                                    && this.data.documentInfo.status_stop_id != 14">
            <b-row>
                <b-col ><h5>Sua entrega é a número <strong>{{ distribution[0].sequence }}</strong></h5></b-col>
                <b-col class="text-right" v-if="isNext == true"><h5>Faltam <strong>{{ getRemaining() }}</strong> entregas para a sua</h5></b-col>
                <b-col class="text-right" v-else><h5><strong>Sua entrega é a próxima!</strong></h5></b-col>
            </b-row>
            <b-progress :max="distribution[0].sequence" height="15px">
                <b-progress-bar :value="distribution[0].progress" variant="info">
                    <strong>{{ distribution[0].progress }} / {{ distribution[0].sequence }}</strong>
                </b-progress-bar>
            </b-progress>
            <template v-if="getOutOfOrder()">
                <i>Motorista pode ter feito as entregas fora da ordem programada</i>
            </template>
        </b-container>
    </div>
</template>

<script>
export default {
    name: 'RouteTracking',
    props: ['distribution'],
    computed:{
        isNext: function(){

            if(this.distribution[0].status_stop_id == 1 || this.distribution[0].status_stop_id == 2) return false;

            return this.getRemaining() > 1
        }
    },
    methods:{
        getRemaining(){
            return this.distribution[0].sequence - this.distribution[0].progress - 1
        },
        getDriverImageUrl() {
            return this.distribution[0].photo
        },
        getOutOfOrder(){
            return this.distribution[0].sequence - this.distribution[0].progress - 1 < 0
        }
    }
}
</script>

<style>
#driver_wrapper{
    font-size: 1.5em;
    color: #495057 !important;
}

#driver_picture {
    width: 60px;
    height: 60px;
    position: relative;
    overflow: hidden;
    border-radius: 50%;
}

#route_tracking_wrapper{
    padding: 10px;
}

#route_tracking_wrapper p{
    margin-left: 5px;
    margin-right: 5px;
    margin-bottom: -15px;
    line-height: 15px;
}

#driver_wrapper h4{
    margin: 0;
}

.card-header{
    color: rgba(13,27,62,0.7);
}

.card-tracking{
     border-bottom: 2px solid #5ed195 !important;
}
</style>
